const ITEMS = [
  "S'NO",
  "Alpine Technical Streetwear",
  "Freeride Approved",
  "Montréal × Les Alpes",
  "Livraison offerte dès 150€",
  "20K Waterproof",
];

export default function Marquee() {
  const Row = () => (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-ice px-6">
            {item}
          </span>
          <span className="text-zinc-600 font-mono text-xs">//</span>
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-white/10 bg-smoke py-3.5"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max">
        <Row />
        <Row />
        <Row />
        <Row />
      </div>
    </div>
  );
}
